import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getGlobalProperty } from "@faire/web--source/common/globals/getGlobalProperty";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackFrontendApisClientSideErrorError } from "@faire/web-api--source/events/frontendApis/error/clientSideError";
import * as React from "react";
import { useEffect } from "react";
import { PageNotFoundTemplate } from "./PageNotFoundTemplate";
export var PageNotFound = function() {
    useEffect(function() {
        trackFrontendApisClientSideErrorError("Page not found", getGlobalProperty("isNextJS") ? "NEXT_JS" : "SPA", getGlobalProperty("originalUrl"), getGlobalProperty("processingServer"));
    }, []);
    return /*#__PURE__*/ _jsx(PageNotFoundTemplate, {
        title: /*#__PURE__*/ _jsx(StrictLocalMsg, {
            id: "F1SyFc",
            defaultMessage: [
                {
                    type: 0,
                    value: "Sorry about that!"
                }
            ]
        }),
        subtitle: /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "nipcVG",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "We can\u2019t find the page you\u2019re looking for."
                        }
                    ]
                }),
                /*#__PURE__*/ _jsx("br", {}),
                /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "8RlIkV",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Maybe some retail therapy can help?"
                        }
                    ]
                })
            ]
        }),
        trackingContainerName: "page_not_found_category_grid"
    });
};
